// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@rugby/XDL/types";

import SelectPresentationPropsDefault from "@insite/mobius/Select/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...SelectPresentationPropsDefault,
        cssOverrides: {
            formField: css`
                position: relative;
                label {
                    position: absolute;
                    font-size: 1rem;
                    left: 0;
                    color: gray;
                    padding: 0 0.3rem;
                    margin: 0 0.5rem;
                    transition: 0.1s ease-out;
                    transform-origin: left top;
                    pointer-events: none;
                    width: auto;
                }
            `,
        },
    },
} as xBaseTheme["select"];
